import protoRoot from "../proto-root";

const name = "stopListeningRPCRequest";

function create() {
  const StopListeningRPCRequest = protoRoot.lookupType(
    "comm.StopListeningRPCRequest"
  );

  const request = StopListeningRPCRequest.create();
  return { payload: request, name };
}

export default {
  create,
  name
};
